import React, {Component, useEffect} from 'react';
import {AutoSizer, List} from 'react-virtualized';
import {motion} from "framer-motion";
import consts from "../../consts";
import {Tooltip} from "antd";
import _ from 'lodash';

class SimpleDataTable extends Component {
  maxWidth = 1;
  
  componentWillReceiveProps(nextProps, nextContext) {
    this.maxWidth = window._.reduce(nextProps.columns, (result, column) => {
      return result + column.width
    }, 0);
  }
  
  render() {
    const isAnimated = !!this.props.isAnimated;
    const WRAPPER = !!this.props.showTooltip ? Tooltip : 'div';
    const showTooltipFn = window._.isFunction(this.props.showTooltip) ? this.props.showTooltip : () => void (0);
    
    const headers = _.map(this.props.columns, (column) => <div className="th"
                                                               key={column.dataIndex}
                                                               style={{
                                                                 ...(column.headerStyle || {}),
                                                                 width: `${column.width / this.maxWidth * 100}%`
                                                               }}>{column.title}</div>);
    const body = <AutoSizer>
      {({ width, height }) => {
        return (<List
          style={{scrollbarWidth: "none"}}
          width={width}
          height={height - 30}
          rowHeight={26}
          rowCount={(this.props.data || []).length}
          // rowRenderer={(props) => this.rowRenderer(props, isAnimated, showTooltipFn, WRAPPER)}
          rowRenderer={(props) => this.rowRenderer1(props, isAnimated, showTooltipFn, WRAPPER)}
          overscanRowCount={3}
        />);
      }}
    </AutoSizer>

    return (
      <div className={this.props.className || ""} style={this.props.style || {}}>
        <div className={!!this.props.scroll ? "table full-height" : "table"}>
          <div className="thead">
            {headers}
          </div>
          <div className="tbody full-height">
            {body}
          </div>
        </div>
      </div>
    );
  }
  
  rowRenderer1 = ({ style, index }, isAnimated, showTooltipFn, WRAPPER) => {
    const item = this.props.data[index];
    
    return <motion.div
      initial={isAnimated ? {opacity: 0} : {opacity: 1}}
      animate={isAnimated ? {
        // transition: {
        //   duration: 0.3,
        // },
        opacity: 1,
      } : false}
      key={index}
      exit={{
        opacity: 0,
        maxHeight: 0,
        backgroundColor: 'white',
        // transition: {
        //   duration: 0.3,
        // }
      }}
      // transition={{
      //   duration: 0.3,
      // }}
      style={style}
    >
      <BodyCard {...this.props} key={index} item={item} showTooltipFn={showTooltipFn} WRAPPER={WRAPPER}
                maxWidth={this.maxWidth} />
    </motion.div>
  }
  
//   rowRenderer = (props, isAnimated, showTooltipFn, WRAPPER) => {
//     // index, // Index of row
//     //   isScrolling, // The List is currently being scrolled
//     //   isVisible, // This row is visible within the List (eg it is not an overscanned row)
//     //   key, // Unique key within array of rendered rows
//     //   parent, // Reference to the parent List (instance)
//     //   style, // Style object to be applied to row (to position it);
//     // // This must be passed through to the rendered row element.
//     const index = props.index;
//     const item = this.props.data[index];
//     const content = <motion.div
//       initial={isAnimated ? {opacity: 0} : {opacity: 1}}
//       animate={isAnimated ? {
//         transition: {
//           duration: 0.3,
//         },
//         opacity: 1,
//       } : false}
//       key={index}
//       exit={{
//         opacity: 0,
//         maxHeight: 0,
//         backgroundColor: 'white',
//         transition: {
//           duration: 0.3,
//         }
//       }}
//       transition={{
//         duration: 0.3,
//       }}
//     >
//       <BodyCard {...this.props} style={props.style} key={index} item={item} showTooltipFn={showTooltipFn} WRAPPER={WRAPPER}
//                 maxWidth={this.maxWidth} />
//     </motion.div>
//
//     return content;
//
//     // return <div
//     //   initial={isAnimated ? {opacity: 0} : {opacity: 1}}
//     //   animate={isAnimated ? {
//     //     transition: {
//     //       duration: 0.3,
//     //     },
//     //     opacity: 1,
//     //   } : false}
//     //   key={index}
//     //   exit={{
//     //     opacity: 0,
//     //     maxHeight: 0,
//     //     backgroundColor: 'white',
//     //     transition: {
//     //       duration: 0.3,
//     //     }
//     //   }}
//     //   transition={{
//     //     duration: 0.3,
//     //   }}>
//     //   <BodyCard {...this.props} key={index} item={item} showTooltipFn={showTooltipFn} WRAPPER={WRAPPER}
//     //             maxWidth={this.maxWidth} />
//     // </div>;
//   }
}

function BodyCard(props) {
  const {item, showTooltipFn, WRAPPER, maxWidth} = props;
  return <WRAPPER className="tr"
                  key={item[props.keyField ?? 'key']}
                  title={showTooltipFn(item) || ''}
                  onClick={(event) => props.onClickTr(event, item)}>
    <motion.div
      animate={{width: item.style?.width || 0, backgroundColor: item.style?.backgroundColor}}
      style={{
        ...item.style, position: 'absolute', height: '100%', zIndex: -1,
      }}
      // transition={{
      //   duration: 0.2,
      // }}
      className={item.trade_type === consts.ORDER_TRADE_TYPE_BUY ? "td l0" : "td r0"}>
    </motion.div>
    {/*<div*/}
    {/*  animate={{width: item.style?.width || 0, backgroundColor: item.style?.backgroundColor}}*/}
    {/*  style={{*/}
    {/*    ...item.style, position: 'absolute', height: '100%', zIndex: 0,*/}
    {/*  }}*/}
    {/*  transition={{*/}
    {/*    duration: 0.3,*/}
    {/*  }} className={item.trade_type === consts.ORDER_TRADE_TYPE_BUY ? "td l0" : "td r0"}>*/}
    {/*</div>*/}
    {
      _.map(props.columns, (column) => {
        let justRender = !!column.justRender;
        return justRender ? column.render(item[`${column.dataIndex}`] || '', item, maxWidth) :
          <div className="td"
               title={props.showTitle ? item[`${column.dataIndex}`] || '' : ''}
               style={{
                 width: `${column.width / maxWidth * 100}%`,
                 whiteSpace: 'nowrap',
                 textOverflow: 'ellipsis',
                 overflow: 'hidden', ...column.style
               }}>
            {!!column.render ? column.render(item[`${column.dataIndex}`] || '', item) : item[`${column.dataIndex}`] || ''}
          </div>
      })
    }
  </WRAPPER>;
}

export default SimpleDataTable;
